;(function ($, window, document) {
    /*********************************
     Odometer
    /********************************* */

    const $odometer = $('.odometer');

    if ($odometer.length) {
        const $odometerEnd = $odometer.data('end-number');
        const $odometerStart = $odometer.data('start-number');
        let odometerView = false;

        function odometerInView() {
            if (!odometerView) {
                if (isScrolledIntoView($odometer)) {
                    odometerView = true;
                    startOdometer();
                }
            }
        }

        odometerInView();

        $(window).on('scroll', () => {
            if (!odometerView) odometerInView();
        });

        function startOdometer() {
            let i = +$odometerStart;
            const end = +$odometerEnd;
            function zeroEnd () {
                setTimeout(() => {
                    i++;
                    if ((i % 10 === 0) && (i < end + 1)) {
                        $odometer.html(i);
                        setTimeout(() => {
                            zeroEnd();
                        }, 300);
                    } else if (i < end + 1) {
                        $odometer.html(i);
                        zeroEnd();
                    } else if (i >= end + 1) {
                        i = +$odometerStart;
                        $odometer.html(i);
                        zeroEnd();
                    }
                }, 700)
            }
            zeroEnd();
        }
    }

    /* ------------------------------------------- */
    /* SCROLLED INTO VIEW                          */
    /* Function return boolean value if element is scrolled into view */
    /* ------------------------------------------- */

    function isScrolledIntoView(elem) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = $(elem).offset().top;
        const elemHeight = $(elem).height();
        const elemMiddle = elemTop + elemHeight / 2;
        const result = elemTop >= docViewTop && elemTop <= docViewBottom || elemMiddle >= docViewTop && elemMiddle <= docViewBottom;

        return result;
    }
})(jQuery, window, document);
